import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Layout from '@/components/layout/Layout'
import HomePage from '@/pages/HomePage'
import ApplicantsPage from '@/pages/ApplicantsPage'
import WireTransfersPage from '@/pages/WireTransfersPage'
import AddWireTransferPage from '@/pages/AddWireTransferPage'
import WireSummaryPage from '@/pages/WireSummaryPage'
import NotFoundPage from '@/pages/NotFoundPage'
import AccountsPage from '@/pages/AccountsPage'

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/applicants" element={<ApplicantsPage />} />
          <Route path="/accounts" element={<AccountsPage />} />
          <Route path="/wire-transfers" element={<WireTransfersPage />} />
          <Route path="/wire-transfers/add" element={<AddWireTransferPage />} />
          <Route path="/wire-transfers/summary/:wireId" element={<WireSummaryPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Layout>
    </Router>
  )
}

export default App
